import React from 'react';

import './Sidebar.css';

const Sidebar = props => {

	const {
		timer,
		points,
		bet
	} = props;

	return (
		<div className="crg-sidebar">
			<a href="https://www.gameshownetwork.com/games" target="_blank" className="ad-unit">
				<img className="desktop" src="images/desktop-play-now.jpg" alt="Play Now" />
				<img className="mobile" src="images/mobile-play-now.jpg" alt="Play Now" />
			</a>
			{/* <a href="#" target="_top" className="ad-unit">
				<img className="desktop" src="images/desktop-watch-now.gif" alt="Watch Now" />
				<img className="mobile" src="images/mobile-watch-now.gif" alt="Watch Now" />
			</a> */}
		</div>
	);
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/Sidebar.jsx